import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaFileUploadGalleryItem from './VaFileUploadGalleryItem.vue'

export default withConfigTransport(VaFileUploadGalleryItem)
